(function () {
  // Strips everything but digits; a leading international "00" prefix is dropped.
  function sanitizeNumber(raw) {
    var digits = String(raw || '').replace(/\D/g, '');
    if (digits.indexOf('00') === 0) digits = digits.slice(2);
    return digits;
  }

  // Amounts arrive in minor units (cents), as Shopify Liquid returns them.
  function formatMoney(cents, currency) {
    var hasFraction = Math.round(cents) % 100 !== 0;
    var amount = (cents / 100).toLocaleString('en-US', {
      minimumFractionDigits: hasFraction ? 2 : 0,
      maximumFractionDigits: 2,
    });
    return currency ? currency + ' ' + amount : amount;
  }

  function buildMessage(order) {
    var lines = [];
    if (order.intro) lines.push(order.intro);
    lines.push('Product: ' + order.title);
    lines.push('Product URL: ' + order.url);
    order.options.forEach(function (option) {
      lines.push(option.name + ': ' + option.value);
    });
    lines.push('Quantity: ' + order.quantity);
    lines.push('Price per item: ' + formatMoney(order.price, order.currency));
    lines.push('Product total: ' + formatMoney(order.price * order.quantity, order.currency));
    if (order.outro) lines.push('', order.outro);
    return lines.join('\n');
  }

  function buildUrl(number, message) {
    return 'https://wa.me/' + sanitizeNumber(number) + '?text=' + encodeURIComponent(message);
  }

  function joinNames(names) {
    if (names.length < 2) return names.join('');
    return names.slice(0, -1).join(', ') + ' and ' + names[names.length - 1];
  }

  // Works out the order from the product data and the customer's current choices.
  // Returns { error } when the selection cannot be ordered.
  function resolveOrder(product, variantId, quantityValue, messages) {
    var variant = null;
    for (var i = 0; i < product.variants.length; i++) {
      if (product.variants[i].id === variantId) variant = product.variants[i];
    }

    if (!variant) {
      var names = product.hasOnlyDefaultVariant ? [] : product.options;
      return { error: messages.select.replace('[options]', joinNames(names) || 'an option') };
    }
    if (!variant.available) return { error: messages.soldOut };

    var quantity = Number(quantityValue);
    if (!Number.isInteger(quantity) || quantity < 1) return { error: messages.quantity };

    var options = [];
    if (!product.hasOnlyDefaultVariant) {
      product.options.forEach(function (name, index) {
        options.push({ name: name, value: variant.options[index] });
      });
    }

    var url = product.url;
    if (!product.hasOnlyDefaultVariant) url += (url.indexOf('?') === -1 ? '?' : '&') + 'variant=' + variant.id;

    return {
      order: {
        intro: product.intro,
        outro: product.outro,
        title: product.title,
        url: url,
        options: options,
        quantity: quantity,
        price: variant.price,
        currency: product.currency,
      },
    };
  }

  var api = {
    sanitizeNumber: sanitizeNumber,
    formatMoney: formatMoney,
    buildMessage: buildMessage,
    buildUrl: buildUrl,
    resolveOrder: resolveOrder,
  };

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = api;
    return;
  }

  if (customElements.get('whatsapp-order')) return;

  customElements.define(
    'whatsapp-order',
    class WhatsAppOrder extends HTMLElement {
      connectedCallback() {
        this.product = JSON.parse(this.querySelector('[data-whatsapp-product]').textContent);
        this.button = this.querySelector('.whatsapp-order__button');
        this.errorWrapper = this.querySelector('.whatsapp-order__error');
        this.errorText = this.querySelector('.whatsapp-order__error-text');
        this.messages = {
          select: this.dataset.msgSelect,
          soldOut: this.dataset.msgSoldOut,
          quantity: this.dataset.msgQuantity,
        };

        this.onClick = this.onClick.bind(this);
        this.update = this.update.bind(this);
        this.button.addEventListener('click', this.onClick);
        document.addEventListener('change', this.update);
        document.addEventListener('input', this.update);
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, () => setTimeout(this.update));
        }
        this.update();
      }

      disconnectedCallback() {
        document.removeEventListener('change', this.update);
        document.removeEventListener('input', this.update);
        if (this.unsubscribe) this.unsubscribe();
      }

      currentSelection() {
        var formId = this.dataset.formId;
        var form = document.getElementById(formId);
        var idInput = form ? form.querySelector('input[name="id"]') : null;
        var quantityInput =
          document.querySelector('input[name="quantity"][form="' + formId + '"]') ||
          (form ? form.querySelector('input[name="quantity"]') : null);

        return resolveOrder(
          this.product,
          idInput && idInput.value ? Number(idInput.value) : null,
          quantityInput ? quantityInput.value : 1,
          this.messages
        );
      }

      update() {
        var result = this.currentSelection();
        this.button.setAttribute('aria-disabled', result.error ? 'true' : 'false');
        if (result.order) {
          this.button.href = buildUrl(this.dataset.number, buildMessage(result.order));
          this.hideError();
        }
      }

      onClick(event) {
        var result = this.currentSelection();
        if (result.error) {
          event.preventDefault();
          this.showError(result.error);
          return;
        }
        this.hideError();
        this.button.href = buildUrl(this.dataset.number, buildMessage(result.order));
      }

      showError(message) {
        this.errorText.textContent = message;
        this.errorWrapper.hidden = false;
      }

      hideError() {
        this.errorWrapper.hidden = true;
      }
    }
  );
})();
